import { CameraConstraintsDto } from '../dto/camera-constraints.dto';

export class CameraConstraints {
  minDistance: number = 0;
  maxDistance: number = Infinity;
  maxAzimuthAngle: number = Infinity;
  minAzimuthAngle: number = Infinity;
  maxPolarAngle: number = Math.PI;
  minPolarAngle: number = 0;

  constructor(cameraConstraintsDto?: CameraConstraintsDto) {
    this.minDistance = cameraConstraintsDto?.minDistance ?? 0;
    this.maxDistance = cameraConstraintsDto?.maxDistance ?? Infinity;
    this.maxAzimuthAngle = cameraConstraintsDto?.maxAzimuthAngle ?? Infinity;
    this.minAzimuthAngle = cameraConstraintsDto?.minAzimuthAngle ?? Infinity;
    this.maxPolarAngle = cameraConstraintsDto?.maxPolarAngle ?? Math.PI;
    this.minPolarAngle = cameraConstraintsDto?.minPolarAngle ?? 0;
  }
}
